import { useMutation } from "@tanstack/react-query";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useGenerateReport = () => {
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (url: string) => await request(url, { method: "POST" }),
  });
};
